import { gql } from 'graphql-tag';

const countyId = gql`
  fragment CountyId on County {
    id
  }
`;

const fishingWaterCountyFields = gql`
  fragment FishingWaterCountyFields on County {
    name
  }
`;

const intersectingCountyNodeFields = gql`
  fragment IntersectingCountyNodeFields on County {
    name
    country {
      countryName
      id
    }
    region {
      regionCode
      name
      localName
    }
  }
`;

export const CountyFragments = {
  id: countyId,
  fishingWaterCountyFields,
  intersectingCountyNodeFields,
};
